// extracted by mini-css-extract-plugin
module.exports = {"air8-popconfirm":"index_air8-popconfirm_etCli"};